import React from 'react';

export interface FrequencyOption {
  value: string;
  label: string;
  description?: string;
}

interface FrequencySelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: FrequencyOption[];
  label?: string;
  className?: string;
  size?: 'sm' | 'md';
}

const FrequencySelector: React.FC<FrequencySelectorProps> = ({
  value,
  onChange,
  options,
  label,
  className = '',
  size = 'sm'
}) => {
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-2'
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`
          ${sizeClasses[size]}
          border border-gray-300 dark:border-gray-600 
          rounded-md shadow-sm 
          focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 
          dark:bg-gray-700 dark:text-white
          bg-white text-gray-900
        `}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FrequencySelector; 